import React, { useContext, useEffect, useState } from 'react'
import Landingpic from '../../molecules/Landingpic'
import Search from '../../molecules/Search'
import Radiotitle from '../../molecules/Radiotitle'
import intropic from "../../../assets/pics/intopic.png"
import livedherewordpic from "../../../assets/pics/livedhereword.png"
import Title from '../../atoms/Title'
import Button from '../../atoms/Button/Button'
import { useNavigate } from 'react-router-dom'
import { AppContext } from '../../../services/Appcontext'
import { useTranslation } from 'react-i18next'

export default function Introsection({introdata, defaultChecked}) {
    const { t, i18n } = useTranslation();
    const isArabic = (i18n.language?.split("-")[0] || "ar") === "ar";
    const localizedName = (item) =>
      (isArabic ? item?.characterName : item?.characterNameE) ||
      (isArabic ? item?.title : item?.titleE) ||
      t("common.noData");
    // const buttonLabels = ['سمير غانم', 'label 2', 'label 3', 'label 4', 'label 5', 'label 6', 'label 7', 'label 8', 'label 9'];
    // console.log("introdata",introdata)
    // console.log("introdata",introdata)
    const {specialities, getSpecialities,}= useContext(AppContext)

    const navigate = useNavigate(); // Initialize navigate
    const {setsearchQuery, searchQuery,setfieldId,setspecialityId, specialityid}= useContext(AppContext)
    const [isActive, setIsActive] = useState(null)
    const [isSpecialityActive, setIsSpecialityActive] = useState(null)

    console.log("the isActive",isActive)
    console.log("the isSpecialityActive",isSpecialityActive)
    // console.log("index before any thing------->",isActive)
    
    useEffect(() => {
        
            if(defaultChecked === "fields" && searchQuery ===""){
            // if(defaultChecked === "fields" ){
                
                    // setIsActive(null)

            }
        }
        ,[searchQuery])

    const onClickfn =(id, title, specialityid)=>{
        console.log("----------------------")
        console.log("id------->",id)
        console.log("title------->",title)
        console.log("specialityid------->",specialityid)
        // console.log("fieldId------->",fieldId)
        console.log("index------->",isActive)
        if(defaultChecked === "fields"){
            if (specialityid) {

                console.log("we have a speciality id-####------>",id === isActive)
                console.log(specialityid === isSpecialityActive ? null : specialityid)
                // User clicked on a speciality, keep the fields active
                setIsSpecialityActive(specialityid === isSpecialityActive ? null : specialityid);
                // setsearchQuery(title);
                setspecialityId(specialityid);
                setfieldId(null)
                // setsearchQuery("");
                
            } else {
                // User clicked on a field, update both field and specialities state
                setIsActive(id === isActive ? null : id);
                setIsSpecialityActive(null); // Reset specialities when selecting a new field
                
                // if (!isActive || isActive !== id) {
                //     console.log("we have a field id------->",id)
                //     setsearchQuery(title);
                //     getSpecialities(id); // Call API with the selected field ID
                // } 
                if (!isActive || isActive !== id) {
                    console.log("we have a field id------->",id)
                    // setsearchQuery(title);
                    getSpecialities(id); // Call API with the selected field ID
                    setfieldId(id); 
                    setspecialityId(null)
                    setsearchQuery("");
                } 
                else {
                    console.log("the input is empty")
                    setsearchQuery("");
                }
            }
            
        }
        else if(defaultChecked === "chars"){
            // console.log("im in characters page")
            // setIsActive(null)
            navigate(`/about.aspx?id=${id}`); // Navigate to the desired URL with the id as a query parameter
        }
    }

    let title=""
    if(defaultChecked === "chars"){
        title=t("chars.mostSearched")
    }
    else if(defaultChecked === "fields"){
        title=t("fields.sectionTitle")
    }
    // console.log("the specialities ",specialities)
return (
    <div className='bg-ed-400 h-fit flex flex-col justify-center items-center'>
            <div className='h-[300px] md:h-[500px] relative w-full'>
                <img
                src={intropic}
                className='h-full w-full'
                alt="lived here intro pic"
                />
                
                <img
                src={livedherewordpic}
                className='absolute top-[155px] md:top-[225px] left-1/2 transform -translate-x-1/2 -translate-y-1/2 h-4/6 w-auto'
                alt="lived here word logo"
                />

                    <div className="absolute top-[240px] md:top-[370px] left-1/2 transform -translate-x-1/2 w-full flex flex-col items-center space-y-4">
                        <div className='w-5/6 md:w-3/4'>
                            <Search 
                            // placeholder={"بحث"}
                            secondary
                            defaultChecked={defaultChecked}
                            />
                        </div>

                        {/* <div className='w-1/4'>
                        <Radiotitle defaultChecked={defaultChecked} />
                        </div> */}
                    </div>
            </div>

            <div className='bg-lue-500 min-h-[150px] m-2 lg:w-5/6 flex flex-col justify-around items-center mt-[30px]'>
                    <div className='text-start bg-ink-200 w-full ms-[10px]'>
                        <Title secondary>{title}</Title>
                    </div>

                    <div className='flex flex-wrap justify-between items-center bg-ink-400 w-full '>

                    {introdata?.map((item, index) => (
                        <div key={index} className='m-[5px]'>

                        <Button 
                            key={index} 
                            primary rounded smallBlackText 
                            onClick={()=>onClickfn(item?.characterId || item.id, localizedName(item))}  
                            active={ item.id === isActive}
                        >
                            {/* {label} */}
                            {localizedName(item)}
                        </Button>
                        </div>
                    ))}
                        
                        {/* <Button primary rounded smallBlackText >سمير غانم</Button> */}
                    </div>

{/* the specialities section  */}
                    {isActive && (
                        <div className='flex flex-wrap justify-evenly items-center bg-ink-400 w-full '>
                            {specialities?.data.map((item, index) => (
                                <div key={index} className='m-[5px]'>
                                    <Button 
                                        primary 
                                        rounded 
                                        smallBlackText

                                        active={ item.id === isSpecialityActive}
                                        onClick={()=>onClickfn(item?.characterId || item.id, localizedName(item), item?.id)}  

                                    >
                                        {(isArabic ? item.title : item.titleE) || t("common.noData")}
                                    </Button>
                                </div>
                            ))}
                        </div>
                    )}

            </div>
    </div>
  )
}
